import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef, useEffect } from "react"
import apiResponse from "../../../../services/apiResponse"
import { ConfirmAlert } from '../../../../helpers/ui/alert'

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input
} from "reactstrap"
import CustomSelect from'../../../../helpers/ui/CustomSelect'


import moment from "moment"
import IndexBloc from "./Blocs/IndexBlock"
import CreateBloc from "../../../Assesment/Managerial/Create/Blocs/CreateBloc"
import Select from "react-select"
import DatePicker from '../../../../helpers/ui/DatePicker'

import TableLamaKerja from './Components/TableLamaKerja'
import TableAkumulasiKetidakhadiranPerUnit from './Components/TableAkumulasiKehadiranPerUnit'
import TableIzinPerUnit from './Components/TableIzinPerUnit'
import TableIzinPerUnit2 from './Components/TableIzinPerUnit2'
import TableIzinSTPerUnit from './Components/TableIzinSTPerUnit'
import TableKehadiranPerUnit from './Components/TableKehadiranPerUnit'
import TableKehadiranPerOrang from './Components/TableKehadiranPerOrang'
import TableKetidakhadiranAlpha from './Components/TableKetidakhadiranAlpha'
import TableAbsensiPerUnit from './Components/TableAbsensiPerUnit'
import TableAbsensiPerOrang from './Components/TableAbsensiPerOrang'
import './custom_css.css'

const jenisLaporanOption = [
    {value:'1',label:'Laporan Masa Kerja (Unit Sekarang)'},
    // {value:'2',label:'Laporan Berdasarkan : Riwayat Jabatan'},
    // {value:'3',label:'Laporan Kehadiran : Tanggal Merah dan Hari Libur'},
]

var yearopt = [];
var tahunsekarang = new Date().getFullYear()
var lastsekarang = tahunsekarang - 10
for(var i = tahunsekarang;i>=lastsekarang;i--){
    yearopt.push({value:i,label:i})   
}
const optBulan = [
    {label : 'Januari', value: 1},
    {label : 'Februari', value: 2},
    {label : 'Maret', value: 3},
    {label : 'April', value: 4},
    {label : 'Mei', value: 5},
    {label : 'Juni', value: 6},
    {label : 'Juli', value: 7},
    {label : 'Agustus', value: 8},
    {label : 'September', value: 9},
    {label : 'Oktober', value: 10},
    {label : 'November', value: 11},
    {label : 'Desember', value: 12}
]

var reformatOptions = function (raw, label, value) {
    return raw.map(function (data) {
        var newObj = {};
        newObj["label"] = data[label];
        newObj["value"] = data[value];

        return newObj;
    });
};

const IndexView = (props) => {
  
    let indexBloc = new IndexBloc();
    let createBloc = new CreateBloc();
    const [activeTab, setactiveTab] = useState("1")    
    const activeRef = useRef();

    const [isLoadingSelectUnit, setIsLoadingSelectUnit] = useState(true);
    const [isLoadingEmployee, setIsLoadingEmployee] = useState(true);
    const [loading, setIsLoadingPopup] = useState(true);
    // Select
    const [optionUnits, setOptionUnits] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState("")
    const [selectedType, setSelectedType] = useState({value:'1',label:'Rekap Ketidakhadiran Perunit'})
    const [selectedEmployee, setSelectedEmployee] = useState("")
    
    // Filter
    const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'))
    const [report_type, setReportType] = useState(1)
    const [employee_uuid, setEmployeeUuid] = useState("")
    const [employeeOption,setEmployeeOption] = useState({nip : "",nama : ""})
    const [bulan,setBulan] = useState("")
    const [tahun,setTahun] = useState("")
    const perorang = ["4", "10"];
    const perunit = ["1", "2","3","5","6","7","8","9"];

    var reformatEmployee = function(raw, label, value) {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = `${data[label]}` ;
          newObj["value"] = data[value];
      
          return newObj;
        });
    };
    useEffect(() => {
        // get data unit
        indexBloc.workUnitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response.result
                        let options = reformatOptions(response, 'work_unit_name_tabs', 'hirarki');
                        setOptionUnits(
                            [
                                {
                                    label: 'Semua',
                                    value: '',
                                },
                                ...options
                            ]
                        )
                        setIsLoadingSelectUnit(false)
                        // setIsLoadingPopup(false)
                    }
                    break
                case apiResponse.ERROR:
                    setIsLoadingSelectUnit(false)
                    // setIsLoadingPopup(false)
                    break
                default:
                    break
            }
            indexBloc.fetchEmployee({})
        })
        indexBloc.empChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        let options = reformatOptions(response, 'employee_full_name', 'employee_uuid');
                        setEmployeeOption(
                            [
                                // {
                                //     label: 'Semua',
                                //     value: '',
                                // },
                                ...options
                            ]
                        )
                        setIsLoadingEmployee(false)
                        setIsLoadingPopup(false)
                    }
                    break
                    case apiResponse.ERROR:
                        setIsLoadingEmployee(false)
                        setIsLoadingPopup(false)
                    break
                default:
                    break
            }
        })

        indexBloc.fetchWorkUnit({})
        indexBloc.fetchEmployee({})

        return () => {
            indexBloc.workUnitChannel?.unsubscribe()
            indexBloc.empChannel?.unsubscribe()
        }
    }, [])

    let additionalFilter = {
        work_unit: selectedUnit.value || "",
        work_unit_name: selectedUnit.label || "",
        report_type: selectedType.value || "",
        start_date: startDate,
        end_date: endDate,
        employee_uuid:selectedEmployee.value,
        bulan:bulan.value,
        tahun:tahun.value,
    };

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const exportExcel = () => activeRef.current.exportExcel()

    function handleButtonExport() {
        exportExcel()
    }

    function handleButtonSearch() {
      reloadActiveRef()
    }

    function handleButtonReset() {
        setSelectedUnit('')
        setTimeout(() => {
            reloadActiveRef()
        }, 300);
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">
                        
                        <Card style={{height:'100%'}}>
                            <CardBody>
                                <div className="float-end">
                                {/* {
                                    (accessRole('create')) ?
                                        <Link to="home.html?create">
                                            <Button color="primary">New Sample</Button>
                                        </Link>
                                    : null
                                } */}
                                </div>
                                <CardTitle>Masa Kerja Pegawai</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Daftar Rekap Laporan Masa Kerja
                                </CardSubtitle>
                                <hr />

                                <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                        Jenis Laporan
                                    </label>
                                    <Col md="4">
                                        <Select
                                            value={jenisLaporanOption.filter(option =>
                                                option.value === selectedType.value)}
                                            onChange={(s) => setSelectedType(s)}
                                            required="required"
                                            options={jenisLaporanOption}
                                            isLoading={isLoadingSelectUnit}
                                            classNamePrefix="select2-unit"
                                            defaultValue={"1"}
                                        />
                                    </Col>
                                </Row>
                            {
                                
                                (perunit.includes(selectedType.value))?
                                <>
                                {/* <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                        Unit Kerja
                                    </label>
                                    <Col md="4">
                                        <Select
                                            value={optionUnits.filter(option =>
                                                option.value === selectedUnit.value)}
                                            onChange={(s) => setSelectedUnit(s)}
                                            required="required"
                                            options={optionUnits}
                                            isLoading={isLoadingSelectUnit}
                                            classNamePrefix="select2-unit"
                                        />
                                    </Col>
                                </Row> */}
                                </>:''
                            }
                            
                                {
                                    (perorang.includes(selectedType.value))?
                                    <>
                                        {/* <Row className="mb-3">
                                            <label htmlFor="fieldGender" className="col-md-2 col-form-label">Pegawai </label>
                                            <Col md="4">
                                            <Select
                                                value={employeeOption?employeeOption.filter(option =>
                                                option.value === selectedEmployee.value):''}
                                                onChange={(s) => setSelectedEmployee(s)}
                                                required="required"
                                                options={employeeOption}
                                                isLoading={isLoadingEmployee}
                                                classNamePrefix="select2-unit"
                                                validate={{ required: { value: true } }}
                                                // defaultValue={"1"}
                                            />
                                                
                                            </Col>
                                        </Row> */}
                                    </>:''
                                }
                                {/* <Row className="mb-3">
                                    <label className="col-md-2">
                                        Periode Mulai
                                    </label>
                                    <Col md="3">
                                        <DatePicker 
                                            name="start_date"
                                            isWeekday={false}
                                            dateFormat="dd/MM/yyyy"
                                            placeholder="Tanggal Mulai"
                                            isAvForm={false}
                                            onChange={val => setStartDate(moment(val).format('YYYY-MM-DD'))}
                                            defaultValue={startDate}
                                            />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <label className="col-md-2">
                                        Periode Akhir
                                    </label>
                                    <Col md="3">
                                        <DatePicker 
                                            name="end_date"
                                            isWeekday={false}
                                            dateFormat="dd/MM/yyyy"
                                            placeholder="Tanggal Selesai"
                                            isAvForm={false}
                                            onChange={val => setEndDate(moment(val).format('YYYY-MM-DD'))}
                                            defaultValue={endDate}
                                            />
                                    </Col>
                                </Row> */}
                               
                                <Row className="mb-3">
                                    <Col md="2"></Col>
                                    <Col md="10">
                                        {/* <Button 
                                            color="primary" 
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button> */}
                                        {' '}
                                        {/* <Button 
                                          color="warning" 
                                          type="button"
                                          onClick={() => {
                                              handleButtonReset()
                                          }}>
                                            <i className="uil-refresh"></i> Reset
                                        </Button> */}
                                        <Button
                                            color="success"
                                            type="button"
                                            onClick={() => {
                                                handleButtonExport()
                                            }}
                                        >
                                            Export Laporan Masa Kerja
                                        </Button>
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    </Col>
                                </Row>

                                <hr />
                                <div>
                                {(() => {
  
                                    switch (selectedType.value) {
                                            case '1':
                                                return (
                                                // <div>You are a Admin.</div>
                                                <TableLamaKerja ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter}/>
                                            )
                                            case '8':
                                                return (
                                                // <div>You are a Admin.</div>
                                                <TableKetidakhadiranAlpha ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter}/>
                                            )
                                            case '2':
                                                return (
                                                <TableAkumulasiKetidakhadiranPerUnit ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter}/>
                                            // <div>You are a Manager.</div>
                                            )
                                            case '3':
                                                return (
                                                    <TableIzinPerUnit ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter}/>
                                            // <div>You are a Manager.</div>
                                            )
                                            case '6':
                                                return (
                                                    <TableIzinPerUnit2 ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter}/>
                                            // <div>You are a Manager.</div>
                                            )
                                            case '7':
                                                return (
                                                    <TableIzinSTPerUnit ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter}/>
                                            // <div>You are a Manager.</div>
                                            )
                                            case '4':
                                                return (
                                                <TableKehadiranPerOrang ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter}/>
                                            // <div>You are a Manager.</div>
                                            )
                                            case '5':
                                                return (
                                                    <TableKehadiranPerUnit ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter}/>
                                                    // <div>You are a Manager.</div>
                                                    )
                                            case '9':
                                                return (
                                                    <TableAbsensiPerUnit ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter}/>
                                                    // <div>You are a Manager.</div>
                                                    )
                                            case '10':
                                                return (
                                                    <TableAbsensiPerOrang ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter}/>
                                                    // <div>You are a Manager.</div>
                                                    )
                                                    default:
                                            return (
                                                // <div>You are a User.</div>
                                                <TableLamaKerja ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter}/>
                                            )
                                        }

                                    })()}
                                </div>
                            </CardBody>
                        </Card>
                        
                    </Col>
                </Row>
            </Container>
            <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan melakukan sinkronisasi data ini?"

                    loadingTitle="Menyiapkan data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil diproses"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal diproses"

                    // showConfirm={confirm}
                    showLoading={loading}
                    // showSuccess={success}
                    // showFailed={failed}

                    // response={this.confirmResponse}
                />
        </Fragment>
    )
}

export default IndexView